import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useShiftSlotsV2PageSize() {
  return useCbhFlag(CbhFeatureFlag.SHIFT_SLOTS_V2_PAGE_SIZE, {
    defaultValue: 10,
  });
}
